if (typeof RecentProductsCache === 'undefined') {
  class RecentProductsCache {
    constructor() {
      this.limit = 10;
      this.currentList = this.getCurrentListFromStorage();
    }

    getCurrentListFromStorage() {
      const raw = localStorage.getItem(`theme:recently-viewed`);
      // ETERNAL YOU: 리퍼브(B급) 상품은 최근 본 목록에서 제외
      return (JSON.parse(raw) || []).filter((item) => !/-b-grade-/.test(item.handle || '') && !(item.element || '').includes('[REFURB]'));
    }

    addProductsToStorage(container = document) {
      const elements = container.querySelectorAll('[data-recent-product-handle]');
      elements.forEach((el) => {
        const handle = el.dataset.recentProductHandle;
        if (/-b-grade-/.test(handle || '')) return;
        const data = {
          handle,
          element: el.innerHTML,
        };
        const position = this.currentList.findIndex((item) => item.handle === handle);
        if (position === -1) {
          this.currentList = [data, ...this.currentList].slice(0, this.limit);
        } else {
          this.currentList = [data, ...this.currentList.filter((_, i) => i !== position)];
        }
      });
      localStorage.setItem('theme:recently-viewed', JSON.stringify(this.currentList));
    }
  }

  window.recentProductsCache = new RecentProductsCache();
  window.recentProductsCache.addProductsToStorage();
}
